import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator
} from "@/components/ui/dropdown-menu";
import { Badge } from "@/components/ui/badge";
import api from "@/lib/api";
import { useNavigate } from "react-router-dom";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const navigate = useNavigate();

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.items || []);
      setUnread(data.unread || 0);
    } catch {}
  };
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const markAllRead = async () => {
    try {
      await api.post("/notifications/read");
      setUnread(0);
      setItems((prev) => prev.map((n) => ({ ...n, read: true })));
    } catch {}
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="notification-bell" className="relative p-2 rounded-md hover:bg-muted transition-colors" aria-label="Notifications">
          <Bell className="w-5 h-5 text-secondary" />
          {unread > 0 && (
            <span data-testid="notification-unread-count" className="absolute -top-0.5 -right-0.5 bg-primary text-primary-foreground text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 grid place-items-center">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80" data-testid="notification-menu">
        <DropdownMenuLabel className="flex items-center justify-between">
          <span>Notifications</span>
          {unread > 0 && (
            <button data-testid="mark-all-read" onClick={markAllRead} className="text-xs text-primary hover:underline">Mark all read</button>
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 && (
            <div className="px-3 py-6 text-center text-sm text-muted-foreground" data-testid="no-notifications">No notifications yet</div>
          )}
          {items.slice(0, 10).map((n) => (
            <DropdownMenuItem
              key={n.id}
              data-testid={`notification-item-${n.id}`}
              onClick={() => { if (n.link) navigate(n.link); }}
              className="flex flex-col items-start gap-1 py-3 cursor-pointer"
            >
              <div className="flex items-center gap-2 w-full">
                {!n.read && <span className="w-2 h-2 rounded-full bg-primary" />}
                <span className="text-sm font-medium text-secondary line-clamp-1">{n.title}</span>
              </div>
              <div className="text-xs text-muted-foreground line-clamp-2">{n.body}</div>
            </DropdownMenuItem>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
